<template>
  <div>
    <div class="thankyou-page" v-if="invoice && page">
      <img class="img-responsive ma-auto" src="../../../../assets/img/gp-head-hbd@2x.png" width="900px" alt="Celebrate" />
      <div class="container">
        <h1 class="text-center">ขอบคุณสำหรับการบริจาค</h1>
        <h2 class="text-center">ที่ช่วยเพิ่มโอกาสทางการศึกษาแก่น้องๆ สำหรับการบริจาคและสร้างเพจในโอกาสพิเศษ</h2>
        <div class="block-white">
          <div class="block-social-share">
            <span>ส่งต่อเพจระดมเงินของคุณให้เพื่อน</span>
            <div class="group-share">
              <vue-goodshare-facebook
                :page_url="pageUrl"
                title_social="Facebook"
                class="social-share-btn"
                has_icon />
              <share-line-button
                :page_url="pageUrl"
                title_social="LINE"
                class="social-share-btn"
                has_icon />
              <div class="share-email button-social">
                <a href="#" @click.prevent="$refs.shareEmailPopup.open()"><i class="far fa-envelope"></i>&nbsp;ส่ง e-card</a>
              </div>
            </div>
          </div>

          <div>
            <div class="block-image-share">
              <img :src="page.share_image" alt="ThankYou Share" />
            </div>
          </div>

        </div>

        <div v-if="showUploadSlipForm">
          <div class="text-center thankyou-remark">
            <p>อีกสักครู่ คุณจะได้รับอีเมลยืนยันการบริจาคจากทางเรา</p><p>หากบริจาคด้วยวิธีการโอนเงิน กรุณายืนยันการโอนเงิน จากแบบฟอร์มด้านล่าง หรือจากลิงก์แบบฟอร์มแจ้งโอนเงินในอีเมลที่ระบบส่งให้</p>
          </div>
        </div>

        <div v-if="!showUploadSlipForm">
          <div class="text-center thankyou-remark">
            <p>อีกสักครู่<br />คุณจะได้รับอีเมลยืนยันการบริจาคจากทางเรา</p>
          </div>
        </div>
        <div class="btn-group">
          <router-link tag="button" :to="`/pages/${page.id}`" type="button" class="btn btn--inline btn--white fs-sm">เพจระดมเงินบริจาค</router-link>
        </div>
      </div> <!--  -->
    </div> <!-- /thankyou-page -->

    <share-email-popup :page="page" ref="shareEmailPopup" />

    <div class="show-uploadslip" v-if="showUploadSlipForm">
      <upload-slip />
    </div>
  </div>
</template>

<script>
  import UploadSlip from '@/components/UploadSlip'
  import VueGoodshareFacebook from 'vue-goodshare/src/providers/Facebook'
  import ShareLineButton from '@/components/ShareLineButton'
  import ShareEmailPopup from '@/components/ShareEmailPopup'

  export default {
    name: 'SpecialEventThankYou',

    components: {
      ShareLineButton,
      UploadSlip,
      VueGoodshareFacebook,
      ShareEmailPopup
    },

    props: {
      invoice: {
        type: Object,
        default: null
      },
      product: {
        type: Object,
        default: null
      },
      page: {
        type: Object,
        default: null
      }
    },

    computed: {
      showUploadSlipForm () {
        return this.invoice && this.invoice.payment_method === 'bank_transfer'
      },

      pageUrl () {
        if (this.page.code.startsWith('blank') || !this.page.code) {
          return `${window.location.origin}/pages/${this.page.id}?v=${this.page.changed}`
        } else {
          return `${window.location.origin}/${this.page.code}?v=${this.page.changed}`
        }
      }
    }
  }
</script>

<style scoped lang="scss">
.thankyou-page {
    background: rgb(252,186,62); /* Old browsers */
    background: -moz-linear-gradient(top, rgba(252,186,62,1) 0%, rgba(243,137,0,1) 100%); /* FF3.6-15 */
    background: -webkit-linear-gradient(top, rgba(252,186,62,1) 0%,rgba(243,137,0,1) 100%); /* Chrome10-25,Safari5.1-6 */
    background: linear-gradient(to bottom, rgba(252,186,62,1) 0%,rgba(243,137,0,1) 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
    color: #242424;
    font-size: 17px;
    position: relative;
    padding-bottom: 2em;
    z-index: 1;
    &:before {
      content: "";
      background: url("../../../../assets/img/bg-hex_trans.png") no-repeat top center;
      background-size: 100%;
      width: 100%;
      height: 100%;
      position: absolute;
      left: 0;
      top: 0;
      z-index: -1;
    }

    h1 {
      color: #242424;
      font-weight: 500;
      font-size: 1.7em;
      line-height: 1.4em;
    }
    h2 { font-size: 1.1em; }
    h2, h3, h4 {
      color: #242424;
      font-weight: 300;
    }
    .container {
      max-width: 700px;
      margin: 0 auto;
    }
    .block-white {
      padding: 1em;
      margin: 2em 0;
      background: #fff;
      border-radius: 4px;
      box-shadow: 0 2px 12px rgba(0,0,0,0.23);
      position: relative;
      z-index: 1;
      &:before {
        background: url("../../../../assets/img/bg-wave.png") no-repeat left center;
        content: "";
        width: 107%;
        height: 110%;
        position: absolute;
        left: -3%;
        right: -5%;
        background-size: cover;
        top: -5%;
        bottom: -5%;
        z-index: -1;
      }
    }
    .block-social-share {
      font-size: 15px;
      margin: 0 0 10px;
      text-align: left;
      span { display: inline-block; width: 50%}
      img { padding-left: 5px; }
      a { z-index: 1; }
    }
    .group-share {
      display: inline-block;
      float: right;
    }
    .block-image-share {
      position: relative;
      text-align: center;
    }
    .social-share-btn {
      line-height: 1.1em;
      padding: 5px;
      margin: 0 0 0 5px;
    }
    .btn-group {
      margin: 0 auto;
      text-align: center;
      .btn {
        height: 40px;
        min-height: 40px;
        padding: 6px 10px;
      }
    }

  .thankyou-remark {
    font-size: 1em;
    margin: 0 auto 2em;
    max-width: 500px;
  }


  @media all and (max-width: 767px) {
    h1 { font-size: 1.1em; padding: 10px 5px 0;}
    h2 { font-size: 1em; }
    p { padding: 0 10px;}
    .block-social-share {
      text-align: center;
      span { display: block; width: 100%; margin-bottom: 5px;}
    }
    .group-share {
      display: block;
      float: none;
    }
    .block-white {
      padding: 0.5em;
    }
    .block-image-share {
      margin: 0;
      padding: 0;
      text-align: center;
      background-size: cover;
    }
    .thankyou-remark { font-size: 0.9em; }
  }

  @media all and (max-width: 400px) {
    .block-social-share {
      text-align: center;
      margin: 5px 0 10px;
      font-size: 0.85em;
      line-height: 1.2em;
    }
    .social-share-btn {
      font-size: 0.85em;
      line-height: 1em;
      margin: 0 0 0 5px;
    }
  }
}
.share-email {
  display: inline-block;
  line-height: 1;
  background: #404040;
  color: #fff;
  padding: 5px;
  font-size: 15px;
  margin: 0 0 0 5px;
  border-radius: 3px;
  > a { color: #fff;}
}


.show-uploadslip .header-wrapper{
  padding: 0;
  background: #fff;
}

.modal__body {
  .modal__content {
    max-height: 400px;
    overflow-y: auto;
  }
}

</style>



// WEBPACK FOOTER //
// thank-you.vue?0dcbc76c